import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Edit, Plus } from 'lucide-react';
import Section from '@/components/Section';
import { Button } from '@/components/ui/button';
import useContactLists from '@/hooks/useContactLists';
import { IContactList } from '@/types';
import DataTable from '../DataTable/DataTable';

const ContactLists = () => {
  const contactLists = useContactLists();
  const drawer = useModal('contact-list-drawer');

  const data = useMemo(() => contactLists.data || [], [contactLists.data]);

  const columns: ColumnDef<IContactList>[] = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'description',
        header: 'Description',
      },
      {
        header: 'Actions',
        cell: ({ row }) => (
          <div className="flex items-center gap-2">
            <Button
              onClick={() => {
                drawer.show({ contactList: row.original });
              }}
            >
              <Edit />
              Edit
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8 -mt-16">
        <Button className="ml-auto" onClick={() => drawer.show()}>
          <Plus />
          Add List
        </Button>
      </div>

      <Section>
        <DataTable data={data} columns={columns} model={contactLists} placeholder={'Search Lists...'} />
      </Section>
    </>
  );
};

export default ContactLists;
